import { ACTION } from './vrf_indoor_actions';
import makeCrudReducer from './make_crud_reducer';

export default makeCrudReducer(ACTION);



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_indoor_reducer.js